import { NgFor, NgIf } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { RecentViewComponent } from '../../shared/recent-view/recent-view.component';
import { BreadcrumbComponent } from '../../shared/breadcrumb/breadcrumb.component';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-category-list',
  imports: [NgFor, RecentViewComponent, BreadcrumbComponent, NgIf, RouterLink],
  templateUrl: './category-list.component.html',
  styleUrl: './category-list.component.css'
})
export class CategoryListComponent implements OnInit, OnDestroy {
  currentBreadcrumb: any = [];
  peremSubscription: Subscription = new Subscription();
  parentCategory: any;
  currentCategory: any;
  CategoryName: any;
  allCategory: string = '';
  category: any = [];
  user: any;
  constructor(
    private util: UtilService,
    private routerState: ActivatedRoute,
    private api: ApiService,
    private router: Router
  ) { }
  ngOnDestroy(): void {
    this.peremSubscription.unsubscribe();
  }

  async ngOnInit(): Promise<void> {
    this.routerState.params.subscribe(params => {
      this.allCategory = params['category'] || 'all'
    })
    try {
      let user = await this.util.getCurrentUser()
      this.user = user;
    } catch (error) {
      console.log(error);
    }
    this.peremSubscription = this.routerState.paramMap.subscribe(
      async (paramMap) => {
        let parent = paramMap.get('category') || 'all';
        if (this.allCategory === 'all') {
          this.currentBreadcrumb = [];
          this.parentCategory = parent;
          this.CategoryName = parent;
          let data = await this.api.getChildCategories(parent!!);
          this.category = data;
          this.currentBreadcrumb = [];
        } else {
          this.currentBreadcrumb = ['all', parent];
          this.parentCategory = parent;
          this.CategoryName = parent;
          let data = await this.api.getChildCategories(parent!!);
          this.category = data;
          this.currentBreadcrumb = ['all', parent];
        }
        // let list = await this.api.getMenu();
        let list = await this.util.fullMenuList()
        let res = await list.filter((val: any) => {
          return val.urlSlug == parent;
        });
        this.currentCategory = res[0];
        this.util.updateTitel(this.CategoryName)
      }
    );
  }
  getCategoryUrl(item: any): string {
    if (this.allCategory === 'all') {
      return `/category/${item.urlSlug}`;
    }
    return `/category/${this.parentCategory}/${item.urlSlug}`;
  }
}
